
import Vue from 'vue'

export default Vue.extend({
  name: 'SignatureSVG',
  props: {
    color: {
      type: String,
      required: true
    }
  }
})
